<template>
  <div class='EnbImgProd02' @click="Select">
    <div class="cont-prc">
      <div class="cont-preco2" v-if="data.oferta > 0 && data.oferta < data.preco">
        {{ MaskToMoney(data.preco) }}
      </div>
      <div class="cont-preco">
        {{ data.oferta > 0 && data.oferta < data.preco ? MaskToMoney(data.oferta) : MaskToMoney(data.preco) }}
      </div>
    </div>
    <img v-if="data.img.length" :src="api + data.img[0].img">
    <div class="cont-img-icon" v-if="!data.img.length">
      <img-icon
      :options="{ width: '180px', height: '150px', color: '#CCCCCC', action: false }"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ImgIcon from '@/components/EnbPainel/Icons/ImgIcon'
import api from '@/mixins/api'
export default {
  name: 'EnbImgProd02',
  components: { ImgIcon },
  props: ['data'],
  mixins: [api],
  methods: {
    ...mapActions(['SetItem01']),
    Select () {
      this.SetItem01(this.data)
        .then(() => {
          if(typeof this.$route.params.categ !== 'undefined') {
            this.$router.push(`/site/${this.$route.params.categ}/${this.data.link}`)
          } else {
            this.$router.push(`/${this.data.link}`)
          }
        })
    },
    MaskToMoney (price) {
      return price.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
    }
  }
}
</script>

<style scoped>
.EnbImgProd02 {
  width: 100%;
  height: 250px;
  overflow: hidden;
  position: relative;
  background-color: #EEE;
  cursor: pointer;
}

img {
  display: block;
  width: 100%;
  height: 250px;
  object-fit: cover;
}

.cont-prc {
  width: 100%;
  box-sizing: border-box;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: end;
  position: absolute;
  padding: 2%;
  padding-bottom: 3%;
  bottom: 0;
  background: linear-gradient(to top, black -10%, transparent 100%);
  z-index: 99;
}

.cont-preco {
  font-size: 22px;
  color: #FFFFFF;
  text-shadow: 1px 1px 2px #000000;
}

.cont-preco2 {
  font-size: 16px;
  color: #FFFFFF;
  text-decoration: line-through;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
  padding-right: 5px;
}

.cont-img-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 250px;
}

img {
  animation: Out 1s forwards;
}

img:hover {
  animation: In 1s forwards;
}

@keyframes In {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.5);
  }
}
@keyframes Out {
  0% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}

@media (max-width: 500px) {
  .EnbImgProd02 {
    height: 300px;
  }

  img {
    height: 300px;
  }

  .cont-img-icon {
    width: 100%;
    height: 300px;
  }
}
</style>
